/*** IMPORTS FROM imports-loader ***/
var global = window;

/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};

